import { MainColor } from '../../palette/colors';

export const getProductDetailsThemeConfig = () => {
  return {
    default: {
      border: 'coolGrey10' as MainColor,
      title: 'navy95' as MainColor,
      label: 'coolGrey60' as MainColor,
      tab: {
        default: 'navy80' as MainColor,
        active: 'forest50' as MainColor,
      },
    },
  };
};
export type ProductDetailsTheme = ReturnType<typeof getProductDetailsThemeConfig>;
